import { render, staticRenderFns } from "./CPNumberInput.vue?vue&type=template&id=533ff8b0&scoped=true"
import script from "./CPNumberInput.vue?vue&type=script&lang=js"
export * from "./CPNumberInput.vue?vue&type=script&lang=js"
import style0 from "./CPNumberInput.vue?vue&type=style&index=0&id=533ff8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ff8b0",
  null
  
)

export default component.exports